export default __webpack_public_path__ + "static/media/NEED-ATTENTION.2a767c1e.png";